const BLOCKED_TOKENS = {
  [56]: [
    '0xc51ef828319b131b595b7ec4b28210ecf4d05ad0', // "EFX"
    '0x1eD5685F345b2fa564Ea4a670dE1Fde39e484751', // "SSWAP"
  ],
};

export default BLOCKED_TOKENS;